import { wrapMethodsWithLogging } from "components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "./BaseApiRepository";

const BinaryContentApiRepository = {
    async getBinaryContent() {
        return await BaseApiRepository.getAsync(`binary-content/`);
    },
    async getIncidentPilotReportById(id: number) {
        return await BaseApiRepository.getAsync(`binary-content/pilot-report/${id}`);
    },
    async getIncidentFinalReportById(id: number) {
        return await BaseApiRepository.getAsync(`binary-content/final-report/${id}`);
    },
};

wrapMethodsWithLogging(BinaryContentApiRepository);

export default BinaryContentApiRepository;
